import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '~/shadcn/ui/dialog'
import { Spinner } from '~/shadcn/ui/spinner'
import { useRemoveBankAccount } from './useRemoveBankAccount'
import { Button } from '~/shadcn/ui/button/button'
import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'

type Props = {
  bankAccountIbanToDelete: string
  onClose: () => void
  onSuccess: () => void
}

function DeleteBankAccountDialog({
  bankAccountIbanToDelete,
  onClose,
  onSuccess,
}: Props) {
  const {
    deleteBankAccount: deleteBankAccountMutation,
    isDeletingBankAccount,
  } = useRemoveBankAccount()

  function handleDeleteBankAccount() {
    deleteBankAccountMutation(
      { iban: bankAccountIbanToDelete },
      {
        onSuccess,
      }
    )
  }

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="px-5 md:px-12 py-12 md:w-fit">
        <DialogHeader>
          <div className="flex flex-col items-center gap-2 text-center">
            <HeadingTwo className="text-2xl md:text-2xl text-center mb-2 md:text-nowrap">
              Ste si istí, že chcete odobrať tento účet?
            </HeadingTwo>
          </div>
        </DialogHeader>
        <DialogFooter className="flex justify-center md:flex-row mt-8 gap-4 w-full">
          <Button
            variant="outline"
            size="2xl"
            onClick={onClose}
            disabled={isDeletingBankAccount}>
            Ponechať tento účet
          </Button>
          <Button
            variant="accent"
            className="md:grow"
            size="2xl"
            onClick={handleDeleteBankAccount}>
            Odobrať účet{` `}
            {isDeletingBankAccount && <Spinner className="size-6" />}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export { DeleteBankAccountDialog }
